module.exports = __webpack_public_path__ + "static/media/develop-04.934ac86f.png";